import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import ReportButtons from 'components/common/ReportButtons'
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Report32 = ({ tableData, showOPK, showOPKtoggle, refresh, title }) => {
  const valueConvert = (val) => {
    return (Number(val).toFixed(2).replace(".",",")+" %")
  }

  const monthsDict = {
    "2": "luty/styczeń", 
    "3": "marzec/luty", 
    "4": "kwiecień/marzec", 
    "5": "maj/kwiecień", 
    "6": "czerwiec/maj", 
    "7": "lipiec/czerwiec", 
    "8": "sierpień/lipiec", 
    "9": "wrzesień/sierpień", 
    "10": "październik/wrzesień", 
    "11": "listopad/październik", 
    "12": "grudzień/styczeń", 
  }

  const getHeader = () => {
    if(Object.getOwnPropertyNames(tableData).length === 0){return ['Numer konta zespołu 4','Nazwa konta zespołu 4']}
    return ['Numer konta zespołu 4','Nazwa konta zespołu 4'].concat(Object.keys(tableData[Object.keys(tableData)[0]].values_dyn).map((month) => { return 'Dynamika '+monthsDict[month]}))
  }
  
  const [isSorted, setIsSorted] = React.useState('Numer konta zespołu 4')
  const [isSortedDesc, setIsSortedDesc] = React.useState(false)
  const toggleSort = (sortBy) => {
    if(isSorted===sortBy){setIsSortedDesc(!isSortedDesc)}else{setIsSorted(sortBy)}
  }
  //pobieranie
  const downloadXlsx = () =>{
    var wb = XLSX.utils.table_to_book(document.getElementById('tabela32'), {sheet:"Sumaryczne zestawienie kosztów", raw:true});
        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        let filename = title+'.xlsx';
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
  }
  const s2ab = (s)=>{
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
  }
  const downloadCSV = () =>{
      let filename = title+'.csv';
      var tableSelect = document.getElementById('tabela32')
      var tableHTML = tableSelect.outerHTML;
      var csv = [];
      var rows = document.querySelectorAll(`#tabela32 tr`);
      
      for (var i = 0; i < rows.length; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");
          
          for (var j = 0; j < cols.length; j++) 
              row.push(cols[j].innerText);
          
          csv.push(row.join(";"));		}
          csv = csv.join("\n")

      var csvFile;
      var downloadLink;
      // CSV FILE
      var universalBOM = "\uFEFF";
      csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
      // Download link
      downloadLink = document.createElement("a");
      // File name
      downloadLink.download = filename;
      // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
      // Make sure that the link is not displayed
      downloadLink.style.display = "none";
      // Add the link to your DOM
      document.body.appendChild(downloadLink);
      // Lanzamos
      downloadLink.click();
  }


  //DOC
  const getTableRow = (values, format={}) => {
    let row = []
    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold, 
              color: format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    let header = getHeader()
    //TABLE
    let rows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(header.length).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill(AlignmentType.LEFT).concat(Array(header.length-2).fill(AlignmentType.RIGHT))
    }
    //header
    rows.push(new TableRow({
      children: getTableRow(header, headerStyle),
      tableHeader: true
    }))
    //body
    let tempRow
    Object.entries(tableData).map(([opk, item]) => {
      tempRow = [opk==='Suma'?'Wartość ogółem':opk, item.name]
      Object.entries(item['values_dyn']).map(([month, value]) => {
        tempRow.push(valueConvert(value))
        return 0
      })
      rows.push(new TableRow({
        children: getTableRow(tempRow, opk==='Suma'?{...bodyStyle, bold: true}:bodyStyle)
      }))

      if(item['children'] !== undefined && showOPK[opk]){
        Object.entries(item['children']).map(([opk2, item2]) => {
          tempRow = [opk2, item2.name]
          {Object.entries(item2['values_dyn']).map(([month2, value2], ind2) => {
            tempRow.push(valueConvert(value2))
            return 0
          })}
          rows.push(new TableRow({
            children: getTableRow(tempRow, {...bodyStyle, backgroundColor:'white' })
          }))
            return 0
        })
      }
      return 0
    })

    let table = new Table({
      rows: rows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      table
    ]

    let doc = new Document({ 
        sections: [{
            properties: { page: { 
                size: { 
                    // orientation: PageOrientation.LANDSCAPE,
                    height: convertMillimetersToTwip(210),
                    width: convertMillimetersToTwip(297) 
                },
                margin: {
                    top: convertMillimetersToTwip(15),
                    right: convertMillimetersToTwip(15),
                    bottom: convertMillimetersToTwip(15),
                    left: convertMillimetersToTwip(15),
                },
            }},
            children: paragraphs
        }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();

    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }

  if(tableData){
    return (
      <> 
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} />
        <table className='table table-border tableRaporty' id='tabela32'>
          <thead className='headerColor'>
            <tr className=''>
            {getHeader().map((title,i) => { return(
              <th key={i} className="" >
                {title}
              </th>) })}
            </tr>
          </thead>
          <tbody className=''>
            {Object.entries(tableData).map(([opk, item]) => {
              return (<><tr key={opk} className='tryColor'>
                <td className='' onClick={() => showOPKtoggle(opk)} style={{ cursor: 'pointer' }}>
                  {showOPK[opk]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>:<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                  {opk}
                </td>
                <td className=''>{item['name']}</td>
                {Object.entries(item['values_dyn']).map(([month, value], ind) => {
                  return (<td key={ind} className='rightAlignCell'>{valueConvert(value)}</td>)
                })}
              </tr>
                {item['children'] !== undefined && showOPK[opk] && <>
                  {Object.getOwnPropertyNames(item['children']).length===0?
                    <tr><td colSpan='3'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                    Object.entries(item['children']).map(([opk2, item2]) => {
                      return (<tr key={opk2} className=''>
                        <td className=''>
                          <span style={{marginLeft: '20px'}}>{opk2}</span>
                        </td>
                        <td className=''>{item2['name']}</td>
                        {Object.entries(item2['values_dyn']).map(([month2, value2], ind2) => {
                          return (<td key={`child${ind2}`} className='rightAlignCell'>{valueConvert(value2)}</td>)
                        })}
                      </tr>)
                    })
                  }</>
                }
              </>)
            })}
          </tbody>
        </table></>
    )
  }else{
    return <Spinner />
  }
}
Report32.propTypes = {
  tableData: PropTypes.object,
  showOPK: PropTypes.object,
  showOPKtoggle: PropTypes.func,
  refresh: PropTypes.bool.isRequired,
}
export default Report32
